import React, { useState, useEffect } from 'react';
import { Container, Box, ToggleButtonGroup, ToggleButton, Stack, Typography } from '@mui/material';
import { TimeClock } from '../../types/TimeClock';

const MAPS_API_KEY = 'AIzaSyCjZjl1MVFRiKThOJDjlM6La9GuAoEYhKw';

type Props = {
  timeClock: TimeClock;
};
export const AttendanceGeoLocationBox = (props: Props) => {
  const { timeClock } = props;

  const [punch, setPunch] = useState('in');

  const pos = punch === 'in' ? timeClock.timeInGeoPosition : timeClock.timeOutGeoPosition;

  return (
    <Container disableGutters>
      <Stack spacing={1}>
        <Stack direction='row'>
          <Box flexGrow={1} />
          <ToggleButtonGroup value={punch} size='small' onChange={(_e, v) => setPunch(v)} exclusive>
            <ToggleButton value='in' sx={{ width: 80 }}>Time In</ToggleButton>
            <ToggleButton value='out' sx={{ width: 80 }}>Time Out</ToggleButton>
          </ToggleButtonGroup>
        </Stack>
        <Box sx={{ height: 600 }}>
          {pos ? (
            <iframe
              title="Embedded Google Maps"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              src={`https://www.google.com/maps/embed/v1/place?key=${MAPS_API_KEY}&q=${pos?.latitude},${pos?.longitude}`}
              allowFullScreen
            />
          ) : (
            <Typography>Data not available.</Typography>
          )}
        </Box>
      </Stack>
    </Container>
  );
};
